import ACTION_TYPES from '../../constants/actionTypes';

export default {
  authToken(state = null, action) {
    switch (action.type) {
      case ACTION_TYPES.LOGIN_SUCCESS:
        return action.payload.auth.token;
      case ACTION_TYPES.SAVE_ANONYMOUS_TOKEN:
        return action.payload.token;
      case ACTION_TYPES.LOGOUT:
        return null;
      default:
        return state;
    }
  },

  authType(state = null, action) {
    switch (action.type) {
      case ACTION_TYPES.LOGIN_SUCCESS:
        return 'Bearer';
      case ACTION_TYPES.SAVE_ANONYMOUS_TOKEN:
        return 'Token';
      case ACTION_TYPES.LOGOUT:
        return null;
      default:
        return state;
    }
  },

  user(state = {}, action) {
    switch (action.type) {
      case ACTION_TYPES.LOGIN_SUCCESS:
        return {
          id: action.payload.id,
          email: action.payload.email,
          name: action.payload.name,
        };
      case ACTION_TYPES.SAVE_ANONYMOUS_TOKEN:
      case ACTION_TYPES.LOGIN:
      case ACTION_TYPES.LOGOUT:
        return {};
      default:
        return state;
    }
  },

  carrier(state = {}, action) {
    switch (action.type) {
      case ACTION_TYPES.LOGIN_SUCCESS:
        return action.payload.carrier;
      case ACTION_TYPES.LOGOUT:
        return {};
      default:
        return state;
    }
  },

  broker(state = {}, action) {
    switch (action.type) {
      case ACTION_TYPES.LOGIN_SUCCESS:
        return action.payload.broker || {};
      case ACTION_TYPES.SAVE_ANONYMOUS_TOKEN:
      case ACTION_TYPES.LOGIN:
      case ACTION_TYPES.LOGOUT:
        return {};
      default:
        return state;
    }
  },

  brokerage(state = {}, action) {
    switch (action.type) {
      case ACTION_TYPES.LOGIN_SUCCESS:
        return action.payload.brokerage || {};
      default:
        return state;
    }
  },
};
